<!-- @bad TODO: Keyboard navigation-->
<ng-container *ngIf="texts$ | async as texts">
    <tui-hosted-dropdown
        *tuiLet="alignState$ | async as alignState"
        #align
        [content]="alignDropdown"
    >
        <button
            tuiIconButton
            type="button"
            size="s"
            icon="tuiIconAlignLeftLarge"
            appearance="icon"
            tuiHintDirection="top-left"
            tuiHintDescribe
            [tuiHint]="texts.justify"
            [pseudoActive]="align.open"
            [focusable]="align.open"
        ></button>
        <ng-template #alignDropdown>
            <div class="t-dropdown">
                <button
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="tuiIconAlignLeftLarge"
                    appearance="icon"
                    class="t-option t-option_margin"
                    [pseudoActive]="!!alignState?.left"
                    [tuiHint]="texts.justifyLeft"
                    (click)="editor.onAlign('left')"
                ></button>
                <button
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="tuiIconAlignCenterLarge"
                    appearance="icon"
                    class="t-option t-option_margin"
                    [pseudoActive]="!!alignState?.center"
                    [tuiHint]="texts.justifyCenter"
                    (click)="editor.onAlign('center')"
                ></button>
                <button
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="tuiIconAlignRightLarge"
                    appearance="icon"
                    class="t-option t-option_margin"
                    [pseudoActive]="!!alignState?.right"
                    [tuiHint]="texts.justifyRight"
                    (click)="editor.onAlign('right')"
                ></button>
                <button
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="tuiIconAlignJustifyLarge"
                    appearance="icon"
                    class="t-option t-option_margin"
                    [pseudoActive]="!!alignState?.justify"
                    [tuiHint]="texts.justifyFull"
                    (click)="editor.onAlign('justify')"
                ></button>
            </div>
        </ng-template>
    </tui-hosted-dropdown>
</ng-container>
